import { HIDE_UNSAVED_CHANGES_CONFIRMATION, SHOW_UNSAVED_CHANGES_CONFIRMATION } from './const';

/**
 * action creator to show confirmation meassage
 * @param {Array} postSaveActions - actions to be dispatched on save click
 * @param {Array} postDiscardActions - actions to be dispatched on discard click
 * @returns {object} action to show confirmation message.
 */
export const showUnsavedChangesConfirmationModal = (postSaveActions, postDiscardActions) => ({
  type: SHOW_UNSAVED_CHANGES_CONFIRMATION,
  postSaveActions,
  postDiscardActions
});

/**
 * action creator to hide confirmation meassage
 * @returns {object} action to show confirmation message.
 */
export const hideUnsavedChangesConfirmationModal = () => ({
  type: HIDE_UNSAVED_CHANGES_CONFIRMATION
});
